import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const MainSummaryBar = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { homePrice, annualIncomeRatio, downPayment, mortgageLoan } = props;

  const shortedHomePrice = homePrice / 1000;
  const shortedDownPayment = downPayment / 1000;
  const shortedMortgageLoan = mortgageLoan / 1000;

  return (
    <Box className={classes.container}>
      <Box className={classes.homePriceBox}>
        <Typography variant="body1" color="inherit" className={classes.label}>
          {t('components.Quiz.SummaryPage.MainSummaryBar.homePrice')}
        </Typography>
        <Box mt={2}>
          <Typography className={classes.marginParagraph} variant="h1">
            <NumberFormat
              value={shortedHomePrice}
              displayType="text"
              suffix="k"
              thousandSeparator
              decimalScale={0}
              prefix="$"
            />
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mt={2}>
          <Typography className={classes.highlight} color="secondary" variant="body1">
            <NumberFormat value={annualIncomeRatio} displayType="text" thousandSeparator decimalScale={1} />
          </Typography>
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MainSummaryBar.annualIncomeTimes')}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.rightBox}>
        <Box className={classes.rightTopBar}>
          <Box className={classes.downPaymentBox}>
            <Typography variant="body1" color="inherit" className={classes.label}>
              {t('components.Quiz.SummaryPage.MainSummaryBar.downPayment')}
            </Typography>
            <Box mt={2}>
              <Typography variant="h1">
                <NumberFormat
                  value={shortedDownPayment}
                  displayType="text"
                  suffix="k"
                  thousandSeparator
                  decimalScale={0}
                  prefix="$"
                />
              </Typography>
            </Box>
          </Box>
          <Box className={classes.mortgageLoanBox}>
            <Typography variant="body1" color="inherit" className={classes.label}>
              {t('components.Quiz.SummaryPage.MainSummaryBar.mortgageLoan')}
            </Typography>
            <Box mt={2}>
              <Typography variant="h1">
                <NumberFormat
                  value={shortedMortgageLoan}
                  displayType="text"
                  suffix="k"
                  thousandSeparator
                  decimalScale={0}
                  prefix="$"
                />
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box py={2} px={4}>
          <Typography variant="body2" color="secondary">
            {t('components.Quiz.SummaryPage.MainSummaryBar.tip')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

MainSummaryBar.propTypes = {
  homePrice: PropTypes.number.isRequired,
  annualIncomeRatio: PropTypes.number.isRequired,
  downPayment: PropTypes.number.isRequired,
  mortgageLoan: PropTypes.number.isRequired,
};

export default MainSummaryBar;



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/MainSummaryBar/MainSummaryBar.js